export enum PluginKey {
  CELL_SELECTION = 'cell-selection',
  COMMENTS = 'comments',
  CONTEXT_MENU = 'context-menu',
  EDIT_CONTENT = 'edit-content',
  QUICK_CALCULATIONS = 'quick-calculations',
  VIEW_SETTINGS_ACTIONS = 'view-settings-actions'
}

export type PluginsState = Record<PluginKey, () => boolean>;

export type { PluginsChecker } from './contracts/plugins-checker';
